// [NOTE: CONSTANT]
import { color, colorT } from "theme"
import { env } from "utils/helpers"

export const DRAG_ID = {
    ID: 'DRAG_ID',
    CUSTOMER_SUPPORT: 'CUSTOMER_SUPPORT'
}

export const ERROR_CODE_SERVER = [400, 406, 500]

export const DEFAULT_ERROR = [
    {
        code: 400,
        name: "errCode.badRequest"
    },
    {
        code: 500,
        name: "errCode.serverError"
    }
]

export const TYPE_GET_ERR_CODE = {
    RECORDING: 'RECORDING'
};

export const RECORING_ERR_CODE = [
    {
        code: 0,
        name: "errCode.success"
    },
    {
        code: 1,
        name: "errCode.recording_info_1"
    },
    {
        code: 2,
        name: "errCode.recording_info_2"
    },
    {
        code: 4,
        name: "errCode.recording_info_4"
    },
    {
        code: 8,
        name: "errCode.recording_info_8"
    },
    {
        code: 16,
        name: "errCode.recording_info_16"
    },
    {
        code: 32,
        name: "errCode.recording_info_32"
    },
    {
        code: 64,
        name: "errCode.recording_info_64"
    },
    {
        code: 128,
        name: "errCode.recording_info_128"
    },
    {
        code: 256,
        name: "errCode.recording_info_256"
    },
    {
        code: 512,
        name: "errCode.recording_info_512"
    },
    {
        code: 1024,
        name: "errCode.recording_info_1024"
    },
    {
        code: 2048,
        name: "errCode.recording_info_2048"
    },
    {
        code: 4096,
        name: "errCode.recording_info_4096"
    },
    {
        code: 8192,
        name: "errCode.recording_info_8192"
    },
    {
        code: 16384,
        name: "errCode.recording_info_16384"
    },
    {
        code: 32768,
        name: "errCode.recording_info_32768"
    },
    {
        code: 524288,
        name: "errCode.recording_info_524288"
    },
    {
        code: 262144,
        name: "errCode.recording_info_262144"
    },
    {
        code: 16777216,
        name: "errCode.recording_info_16777216"
    },
    {
        code: 1048576,
        name: "errCode.recording_info_1048576"
    },
    {
        code: 2097152,
        name: "errCode.recording_info_2097152"
    },
    {
        code: 4194304,
        name: "errCode.recording_info_4194304"
    },
    {
        code: 8388608,
        name: "errCode.recording_info_8388608"
    }
]

export const RECORDING = {
    PERMISSIONS: {
        VIEW: {
            value: 2,
            title: 'recording.recordShare.permission.view'
        },
        EDIT: {
            value: 3,
            title: 'recording.recordShare.permission.edit'
        },
    }
}

export const CONFIG_SYSTEM_CODE = {
    PAGE_INFO: 'PAGE_INFO'
}

export const STATUS_MEETING_EVENT = {
    NOT_START: 'NOT_START',
    PROGRESS: 'PROGRESS',
    ENDED: 'ENDED',
    CANCELED: 'CANCELED',
    EXPIRED: 'EXPIRED',
}

export const TYPE_CONVERT_MEETING = {
    HISTORY: 'HISTORY',
    DEFAULT: 'DEFAULT'
}

export const LABEL_STATUS_MEETING_EVENT = {
    NOT_START: "meeting.type.not_start",
    PROGRESS: "meeting.type.process",
    ENDED: "meeting.type.end",
    CANCELED: "meeting.type.trash",
    EXPIRED: "meeting.type.over"
}

export const COLOR_MEETING_EVENT = {
    NOT_START: colorT.meeting.notStart,
    PROGRESS: colorT.meeting.progress,
    ENDED: colorT.meeting.ended,
    CANCELED: colorT.meeting.canceled,
    EXPIRED: colorT.meeting.expired,
}

export const COLOR_MEETING_GRID_EVENT = {
    NOT_START: colorT.meetingGrid.notStart,
    PROGRESS: colorT.meetingGrid.progress,
    ENDED: colorT.meetingGrid.ended,
    CANCELED: colorT.meetingGrid.canceled,
    EXPIRED: colorT.meetingGrid.expired,
}

export const BACKGROUNDCOLOR_MEETING_EVENT = {
    EXP_END: colorT.meetingBackground.expEnd,
    DEFAULT: colorT.meetingBackground.default
}

export const BORDER_COLOR_RIGHT_MEETING_EVENT = {
    PROGRESS: colorT.meetingBorder.right
}

export const NUMBER_OF_MONTH = [
    "month.jan",
    "month.feb",
    "month.mar",
    "month.apr",
    "month.may",
    "month.jun",
    "month.jul",
    "month.aug",
    "month.sep",
    "month.oct",
    "month.nov",
    "month.dec",
]

export const SLICE_NAME = {
    PACKAGE_MANAGEMENT: 'packageManagement',
    MANAGER_MEETING: 'managerMeeting',
    MEETING_MONITOR: 'meetingmonitor',
    MANAGER_USER_SIP: 'managerusersip',
    MANAGER_USER: 'manageruser',
    MANAGER_RECORDING: 'managerRecording',
    ACCESS_LOG: 'accesslog',
    HISTORY_PAGE: 'historyPage',
    APP: 'app',
    COMMON: 'common',
    SHARING_RECORD: 'sharingRecord',
    BACKUP: 'backup',
    MANAGER_VERSION: 'managerVersion',
    LOGIN: 'login',
    THEME: 'theme',
    MCU: 'mcu',
    ORGANIZATION_TREE: 'organizationTree',
    LAYOUT: 'layout'
}

export const TYPE_UPDATE_LOADING_BUTTON = {
    ADD: 'ADD',
    REMOVE: 'REMOVE',
    CLEAR: 'CLEAR'
}

export const ID_LOADING_BUTTON = {
    CONFIRM_DIALOG: 'btn-confirm-dialog'
}

export const TIME_FORMAT = {
    FULL: 'DD/MM/YYYY hh:mm:ss',
    FULL_24h: 'DD/MM/YYYY HH:mm:ss',
    CALENDAR_EVENT: 'YYYY-MM-DD',
    SEARCH_DATE: 'YYYY-MM-DD HH:mm:ss'
}

export const _PADDING = {
    COMPONENT: '20px'
}

export const ICON = {
    STATUS: {
        ACTIVE: 'ACTIVE',
        DEFAULT: 'DEFAULT'
    },
    COLOR: {
        ACTIVE: color.iconActive,
        DEFAULT: color.grey01
    }
}
export const CALENDAR_VIEW = {
    LIST_WEEK: 'listWeek',
    TIME_GRID_DAY: 'timeGridDay',
    TIME_GRID_WEEK: 'timeGridWeek'
}

export const NS_TRANS = {
    COMMON: 'common',
    MAIN: 'translation',
    MANAGE_MEETING: 'manageMeeting',
    MANAGE_ROLE: 'manageRole',
    MANAGE_POSITION: 'managePosition',
    MANAGE_USER: 'manageUser',
    PG_MEETING: 'pgMeeting',
    PG_WHITEBOARD: 'pgWhiteboards',
    PG_PROFILE: 'pgProfile',
    PG_RECORDINGS: 'pgRecordings',
    PG_PHONEBOOK: 'pgPhonebook'
}

export const POPOVER = {
    POSITION: {
        CENTER: 'center',
        LEFT: 'left',
        RIGHT: 'right'
    }
}

export const USER = {
    TOKEN: 'token',
    REFRESH_TOKEN: 'refreshToken',
    COOKIES_TOKEN_KEY: env("REACT_APP_COOKIES_TOKEN_KEY") || "vmp_token_test171",
    COOKIES_REFRESH_TOKEN_KEY: env("REACT_APP_COOKIES_REFRESH_TOKEN_KEY") || "vmp_refresh_token_test171"
}

export const TOAST = {
    TYPE: {
        SUCCESS: 'success',
        INFO: 'info',
        WARNING: 'warning',
        ERROR: 'error'
    }
}

export const ROLE_IN_ROOM = {
    OWNER: "owner",
    HOST: "host",
    CO_HOST: "coHost",
    PARTICIPANT: "participant"
}

export const RolesPariticpant = [
    {
        name: 'Người sở hữu',
        value: 'owner'
    },
    {
        name: 'Chủ trì',
        value: 'host'
    },
    {
        name: 'Đồng chủ trì',
        value: 'coHost'
    },
    {
        name: 'Người tham dự',
        value: 'participant'
    }

]

/**
 * Danh sách config code
 */
export const CONFIG_CODE = {
    TIMEOUT_CONFIRM_REFRESH_TOKEN: 'TIMEOUT_CONFIRM_REFRESH_TOKEN', // Thời gian hiển thị popup xác nhận đang trong section
    WHITELIST_PROVIDER: 'WHITELIST_PROVIDER',
    MFA_DOMAINS_REQUIRED: 'MFA_DOMAINS_REQUIRED'
}

/**
 * Danh sách config code gọi api
 */
export const CONFIG_CODE_GET = [
    CONFIG_CODE.TIMEOUT_CONFIRM_REFRESH_TOKEN
]

export const COMPONENT_RENDER = {
    OTP: 0,
    CHANGE_PASSWORD: 1,
    VERIFY_EMAIL: 2,
    CHANGE_EMAIL: 3
}